import { BaseModel } from './base';
import { Product } from './product';

export interface ShoppingCartItem extends BaseModel {
  id: number;
  product_id: number;
  product_attr_value_ids: number[];
  product_priced_attr_value_id: number;
  quantity: number;
  amount: number;

  product: Product;
}

export enum UserPaymentIntentStatus {
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

export interface UserPaymentIntent extends BaseModel {
  id: string;
  payment_intent_id: string;
  payment_intent_client_secret: string;
  subtotal: number;
  shipping_fee: number;
  total: number;
  status: UserPaymentIntentStatus;
  items: ShoppingCartItem[];
}

export interface ShippingAddress {
  name: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface UserShippingAddress extends BaseModel {
  id: number;
  fname: string;
  lname: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface UserOrder extends BaseModel {
  id: string;
  user_id: number;
  payment_intent_id: string;
  subtotal: number;
  shipping_fee: number;
  total: number;
  status: string;
  shipping: ShippingAddress;
  item_quantity: number;

  items: UserOrderItem[];
}

export interface UserOrderItem extends BaseModel {
  id: number;
  order_id: string;
  product_id: number;
  product_attr_value_ids: number[];
  product_priced_attr_value_id: number;
  quantity: number;
  amount: number;
  product: Product;
}
